import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import BalancosFinanceiros from '../../components/balanco/listar/financeiro';


function BalancosFinanceirosScreen () {
    return (
        <Fragment>
            <Head titulo="Balanços Financeiros do Município de Macuco"/>
            <Header />
            <Container>
                <BalancosFinanceiros />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default BalancosFinanceirosScreen;